import gql from 'graphql-tag';

export default gql`
  query searchProperties($text: String) {
    properties(where: { OR: [
      { address_contains: $text },
      { code_contains: $text },
      { erfNumber_contains: $text },
      { suburb_contains: $text }
    ]}) {
      createdAt
      address
      id
      erfNumber
      suburb
      code
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/SearchProperties.ts